module.exports = __webpack_public_path__ + "static/media/CaptainsTreasure_EN.1020e864.png";